export const ITEM_IN_CART_MESSAGE = 'The service item you have selected is already in your Quote.'
export const ALREADY_IN_QUOTE = 'Already In Quote'
export const ITEM_DISCONTINUED = 'Item discontinued'
